import { FC, HTMLAttributes } from "react";
import Markdown from "react-markdown";

import { Col, Copilot, Icon, Row, Typography } from "@ctra/components";
import { useTranslation, Enterprise } from "@ctra/i18n";

import styles from "./StockingDensityFooter.module.less";

const { Title, Paragraph } = Typography;

const {
  insights: {
    extensions: { stockingDensity }
  }
} = Enterprise;

/**
 * Footer for the onboarding insight
 * @param {string | undefined} className
 * @returns {JSX.Element}
 * @constructor
 * @todo basically the same as the onboarding footer but new content, so maybe make it generic
 */
export const StockingDensityFooter: FC<HTMLAttributes<HTMLDivElement>> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <Row wrap={false} gutter={[16, 0]} className={className}>
      <Col>
        <Icon component={Copilot} className={styles.Icon} />
      </Col>
      <Col flex={1}>
        <Title level={5}>
          <Markdown>{t<string>(stockingDensity.footer.title)}</Markdown>
        </Title>
        <Paragraph>
          <Markdown>{t<string>(stockingDensity.footer.description)}</Markdown>
        </Paragraph>
      </Col>
    </Row>
  );
};
